<template>
    <div id="video-ref">
        <!--<video ref="video" v-show="this.$store.state.app.playVideoRef || isPlayingRef || isMobile" :class="{ 'is-playing': isPlayingRef }">
            <video ref="video_ref" muted loop :class="{ 'is-playing': isPlayingRef }" v-if="!isMobile">-->
        <video ref="video_ref" muted playsinline :class="{ 'is-playing': isPlayingRef }" preload="auto" loop :poster="srcPoster">
            <source :src="srcVideoMp4" type="video/mp4" />
        </video>

        <!--<video ref="video_ref" muted loop :class="{ 'is-playing': isPlayingRef }" v-if="isMobile">
                <source :src="require('@/assets/showreel_mobil.mp4')" type="video/mp4" />
            </video>-->

        <div id="controls">
            <div @click="playVideo" class="btn-play">
                <PlayVideo v-if="!this.$store.state.app.playVideoRef && !endVideo" class="icon-play" />
                <PauseVideo v-if="this.$store.state.app.playVideoRef && !endVideo" class="icon-pause" />
            </div>

            <div @click="reloadVideo" class="btn-reload">
                <Reload v-if="!this.$store.state.app.playVideoRef && endVideo" class="icon-reload" />
            </div>

            <div @click="runMute()" class="btn-mute">
                <SoundOn v-if="!soundMuted" />
                <SoundOff v-if="soundMuted" />
            </div>
        </div>

        <div id="timer-video">
            <div>
                {{ timer }}
            </div>
        </div>

        <div id="progressbar">
            <div @click="clickCurrentTime" @mousedown="mouseDownCurrentTime"><div ref="progressbar"></div></div>
        </div>

        <Transition>
            <div class="scrolldown" v-if="showScroll">
                <div></div>
            </div>
        </Transition>

        <!--<div class="loader" v-if="!videoRefLoaded">
            <div>
                <IconHaikara color="#FF0000" class="logo-icon" />
                <div class="cm-spinner"></div>
            </div>
        </div>-->
    </div>
</template>

<script>
import IconHaikara from "./img/IconHaikara.vue";
import PlayVideo from "../components/img/PlayVideo.vue";
import PauseVideo from "../components/img/PauseVideo.vue";
import Reload from "../components/img/Reload.vue";
import SoundOn from "../components/img/SoundOn.vue";
import SoundOff from "../components/img/SoundOff.vue";

export default {
    name: "VideoRef",
    props: ["clientX", "mouseUpStatus"],
    data() {
        return {
            local: this.$i18n.locale,
            isMouseMove: false,
            timeoutMouseMove: false,
            isPlayingRef: false,
            scrollVal: 0,
            isMobile: false,
            soundMuted: true,
            srcVideoMp4: null,
            srcPoster: null,
            playPromise: false,
            timer: "",
            showScroll: false,
            endVideo: false,
            videoRefLoaded: false,
            changeCurrentTime: false,
        };
    },
    components: {
        PlayVideo,
        PauseVideo,
        SoundOn,
        SoundOff,
        Reload,
        IconHaikara,
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;

            let windowWidth = window.innerWidth;
            if (windowWidth < 992) this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4");
            else this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4");
        },
        "$store.state.app.playVideoRef": {
            handler(isPlay) {
                let video = this.$refs["video_ref"];
                if (video) {
                    if (isPlay) {
                        video.play();
                        this.isPlayingRef = true;
                    } else {
                        video.pause();
                        this.isPlayingRef = false;
                    }
                    this.isMouseMove = false;
                }
            },
        },
        "$store.state.app.resetRef": {
            handler(reset) {
                let video = this.$refs["video_ref"];
                if (video && reset) {
                    this.isPlayingRef = false;
                    video.currentTime = 0;
                    this.$store.dispatch("app/setResetVideoRef", false);
                }
            },
        },
        "$store.state.app.loaderWebsite": function (display) {
            let video = this.$refs["video_ref"];
            if (video) {
                video.play();
                this.isPlayingRef = true;
            }
        },
        mouseUpStatus: function (status) {
            this.changeCurrentTime = false;
        },
        clientX: function (clientX) {
            if (this.changeCurrentTime) this.setCurrentTime(clientX);
        },
    },
    mounted() {
        this.local = this.$i18n.locale;
        let _this = this;
        this.$store.dispatch("app/setPlayVideoRef", true);
        let progressbar = this.$refs["progressbar"];

        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        let video = this.$refs["video_ref"];
        if (video) {
            video.addEventListener(
                "loadeddata",
                function () {
                    _this.videoRefLoaded = true;
                    _this.$store.dispatch("app/setVideoRefLoaded", true);
                },
                false
            );

            video.addEventListener("timeupdate", function () {
                let videoDuration = video.duration;
                let remainingDuration = videoDuration - video.currentTime;
                //let hours = parseInt(remainingDuration / (60 * 60), 10);
                let minutes = parseInt(remainingDuration / 60, 10);
                let seconds = remainingDuration % 60;

                //hours = hours < 10 ? '0' + hours : hours;

                seconds = seconds.toFixed(0) < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                _this.timer = minutes + ":" + seconds;

                if (progressbar) {
                    let percentCurrentTime = (video.currentTime * 100) / videoDuration;
                    progressbar.style.width = percentCurrentTime + "%";
                }
            });

            video.addEventListener("ended", function () {
                _this.showScroll = true;
                //_this.endVideo = true;
            });
        }
    },
    created() {
        this.srcVideoMp4 = window.innerWidth < 992 ? require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4") : require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4");
        this.srcPoster = window.innerWidth < 992 ? "./refs/poster_video.png" : "./refs/poster_video.png";

        window.addEventListener("scroll", this.handleScroll);
    },
    updated() {},
    unmounted() {
        this.$store.dispatch("app/setPlayVideoRef", false);
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll(e) {
            let video = this.$refs["video_ref"];
            // PLAY / PAUSE
            if (video) {
                let videoHieght = video.clientHeight;
                if (!this.endVideo) {
                    if (videoHieght < window.scrollY) this.$store.dispatch("app/setPlayVideoRef", false);
                    else {
                        if (!this.$store.state.app.pauseVideoRefByUser) this.$store.dispatch("app/setPlayVideoRef", true);
                    }
                }
            }
        },
        runMute(soundOn = false) {
            let video = this.$refs["video_ref"];
            if (video) {
                video.muted = soundOn ? false : !video.muted;
                this.soundMuted = video.muted;
            }
        },
        setCurrentTime(x) {
            let video = this.$refs["video_ref"];
            let videoDuration = video.duration;
            let percentCurrentTime = (x * 100) / window.innerWidth;
            let newCurrentTime = (percentCurrentTime * videoDuration) / 100;

            this.$refs["progressbar"].style.width = percentCurrentTime + "%";

            video.currentTime = newCurrentTime;

            let remainingDuration = videoDuration - video.currentTime;
            let minutes = parseInt(remainingDuration / 60, 10);
            let seconds = remainingDuration % 60;
            seconds = seconds.toFixed(0) < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            this.timer = minutes + ":" + seconds;
        },
        clickCurrentTime(e) {
            this.setCurrentTime(e.clientX);
        },
        mouseDownCurrentTime(e) {
            this.changeCurrentTime = true;
        },
        playVideo() {
            this.$store.dispatch("app/setPlayVideoRef", !this.$store.state.app.playVideoRef);
            this.$store.dispatch("app/setPauseVideoRefByUser", !this.$store.state.app.pauseVideoRefByUser);
        },
        reloadVideo() {
            this.endVideo = false;
            this.showScroll = false;
            this.$store.dispatch("app/setResetVideoRef", false);
            this.$store.dispatch("app/setPlayVideoRef", true);
        },
        isItMobile() {
            let windowWidth = window.innerWidth;
            if (windowWidth < 992 && !this.isMobile) {
                this.isMobile = true;
                this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4");
            } else if (windowWidth >= 992 && this.isMobile) {
                this.isMobile = false;
                this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/motion_projets_2024_test.mp4" : "@/assets/motion_projets_2024_test.mp4");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#video-ref {
    margin: auto;
    width: 100%;
    //max-width: 1350px;
    position: relative;
    display: flex;

    .loader {
        display: flex;
        justify-content: center;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: url("@/assets/img/bg_loader.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        z-index: 9;
        position: sticky;

        > div {
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
        }
    }

    .logo-icon {
        width: 80px;
        height: auto;
        position: absolute;
        fill: #fff;
    }

    .cm-spinner {
        height: 180px;
        width: 180px;
        border: 8px solid transparent;
        border-radius: 50%;
        border-top: 8px solid #fff;
        border-bottom: 8px solid #fff;
        -webkit-animation: spin 4s linear infinite;
        animation: spin 4s linear infinite;
        position: relative;
    }

    .cm-spinner::before,
    .cm-spinner::after {
        content: "";
        position: absolute;
        top: 6px;
        bottom: 6px;
        left: 6px;
        right: 6px;
        border-radius: 50%;
        border: 8px solid transparent;
    }

    .cm-spinner::before {
        border-top-color: #fff;
        -webkit-animation: 3s spin linear infinite;
        animation: 3s spin linear infinite;
    }

    .cm-spinner::after {
        border-top-color: #fff;
        -webkit-animation: spin 1.5s linear infinite;
        animation: spin 1.5s linear infinite;
    }

    video {
        width: 100%;
        //border-radius: 50px;
        overflow: hidden;
    }

    #progressbar {
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        > div {
            background-color: rgb(255, 255, 255, 0.2);
            position: sticky;
            top: calc(100vh - 8px);
            z-index: 1;
            display: block;
            cursor: pointer;
            height: 8px;
            width: 100%;

            > div {
                background-color: rgba(255, 255, 255, 0.6);
                display: block;
                cursor: pointer;
                height: 100%;
            }
        }
    }

    #timer-video {
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        > div {
            position: sticky;
            top: calc(100vh - 35px - 1rem);
            z-index: 1;
            display: block;
            cursor: pointer;
            margin-bottom: 1rem;
            color: rgb(255, 255, 255, 0.5);
            height: 35px;
            display: flex;
            align-items: center;
            font-family: "Oswald", sans-serif;
            font-size: 1.2rem;
            font-weight: 600;
        }
    }

    #controls {
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    .btn-reload,
    .btn-play {
        position: sticky;
        top: calc(100vh - 35px - 1rem);
        z-index: 1;
        display: block;
        cursor: pointer;
        margin-right: 0.5rem;
        margin-bottom: 1rem;

        svg {
            width: 35px;
        }
    }

    .btn-mute {
        position: sticky;
        top: calc(100vh - 35px - 1rem);
        z-index: 1;
        display: block;
        cursor: pointer;
        margin-bottom: 1rem;

        svg {
            width: 35px;
        }
    }
}

/* Scroll icon */
.scrolldown {
    position: absolute;
    top: 0;
    bottom: 2rem;
    height: calc(100% - 2rem);
    left: calc(50vw - 15px);
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    > div {
        position: absolute;
        width: 30px;
        height: 50px;
        border: 3px solid #ff0000;
        border-radius: 25px;
        position: sticky;
        top: calc(100vh - 50px - 2rem);
        transition: all 0.5s;

        &::before {
            content: "";
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            width: 6px;
            height: 6px;
            background-color: #ff0000;
            border-radius: 100%;
            box-shadow: 0px -5px 3px 1px rgba(255, 0, 0, 0.6);
            animation: scrolldown-anim 2s infinite;
        }

        &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
            width: 7px;
            height: 7px;
            border: 2px solid #ff0000;
            border-top: none;
            border-left: none;
            animation: pulse 2s infinite;
        }
    }
}
@keyframes scrolldown-anim {
    0% {
        opacity: 0;
        height: 6px;
    }
    40% {
        opacity: 1;
        height: 10px;
    }
    80% {
        opacity: 0;
        transform: translate(-50%, 20px);
        height: 10px;
    }
    100% {
        opacity: 0;
        height: 3px;
    }
}

// Transition icone scroll
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

@-webkit-keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

// HEIGHT
@media (max-height: 800px) {
}

@media (max-height: 650px) {
}

// WIDTH
@media (max-width: 1400px) {
}

@media (max-width: 1200px) {
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
}

@media (max-width: 576px) {
}
</style>
